var $ff8d0517615646bd$exports = {};
$ff8d0517615646bd$exports = {
    "collapse": `Skjul`,
    "expand": `Utvid`
};


export {$ff8d0517615646bd$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
